
export default {
    name: 'clipboard',
    components: {},
    props: [],
    data() {
        return {
            clip_loading: true
        }
    },

    computed: {
        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },
    },

    mounted() {
        this.getListeClipBoard()
    },

    methods: {
        async copyToClipboard(char, event) {
            event.preventDefault()
            try {
                await navigator.clipboard.writeText(char);
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }
        },

        getListeClipBoard() {
            this.clip_loading = true
            this.$store.dispatch("getListeTypeMixData", 'clipboard').then(() => {


                this.clip_loading = false
            })
        },
    }
}


